import { z } from 'zod';
const baseActor = {
    id: z.string().describe('The UUID extracted from the "type:id" portion of the @[]() entity tag.'),
    name: z.string().describe('The display name found inside the @[...] brackets.'),
    reasoning: z.string().describe('Specific justification linking the instruction rules to the document content.'),
};
export const WorkflowApproverSchema = z.object(Object.assign(Object.assign({}, baseActor), { type: z.enum(['user', 'team']).describe('The entity type ("user" or "team") extracted from the "type:id" portion.') }));
export const WorkflowSignatorySchema = z.object(Object.assign(Object.assign({}, baseActor), { type: z
        .enum(['user', 'contact'])
        .describe('The entity type ("user" or "contact") extracted from the "type:id" portion.'), role: z
        .enum(['SIGNATORY', 'APPROVER', 'VIEWER'])
        .default('SIGNATORY')
        .describe('The e-signing role assigned by the instructions. Defaults to "SIGNATORY" when the rule does not state a role explicitly (e.g. "@[Alice](contact:…) as Approver" → APPROVER; "@[Bob](user:…) for review only" → VIEWER).') }));
export const WorkflowApprovalResultSchema = z.object({
    summary: z
        .string()
        .describe('A concise audit summary explaining the logic behind the approval requirement. Do not mention names.'),
    isApprovalRequired: z.boolean().describe('True if any business rule in the {instructions} triggers a requirement.'),
    approvers: z
        .array(WorkflowApproverSchema)
        .describe('List of entities identified via the @[]() syntax in the {instructions}.'),
});
export const WorkflowSignatoryResultSchema = z.object({
    summary: z.string().describe('A high-level summary of signing authority logic applied. Do not mention names.'),
    signatories: z
        .array(WorkflowSignatorySchema)
        .describe('List of entities identified via the @[]() syntax in the {instructions}, each with an e-signing role.'),
});
